import classNames from 'classnames';

import { Tag } from '@/core/tamagoshi/Tag/Tag';

import styles from './ModelVariations.module.scss';

interface ModelVariationsProps {
  modelsCount: number;
  translations: { label: string };
  className?: string;
}

export const ModelVariations = ({
  modelsCount,
  translations,
  className,
}: ModelVariationsProps) => {
  if (modelsCount < 2) return null;

  return (
    <Tag color="lightGrey" className={classNames(className, styles.root)}>
      {modelsCount} {translations.label}
    </Tag>
  );
};
